type EventDate = string | Date | null | undefined;

const toTime = (value: EventDate) =>
  value == null || value === '' ? NaN : new Date(value).getTime();

export const EVENT_END_BEFORE_START_MESSAGE = '`endDate` must be on or after `startDate`.';

// An event may start and end at the same moment; only an end strictly before the start is wrong.
export function isEventEndBeforeStart(startDate: EventDate, endDate: EventDate): boolean {
  const start = toTime(startDate);
  const end = toTime(endDate);
  return Number.isFinite(start) && Number.isFinite(end) && end < start;
}

export const FREE_TICKET_TYPE_PRICE_MESSAGE =
  'A ticket type with `pricing: "free"` must have `price` 0 or no price.';

// Checkout charges a free ticket type's stored price, so a free ticket with a price is not free.
export function isFreeTicketTypeWithPrice({
  pricing,
  price,
}: {
  pricing?: string | null;
  price?: number | null;
}): boolean {
  return pricing === 'free' && typeof price === 'number' && price !== 0;
}
